import React from "react";
import "./loader_btn.css";

const Loader_btn = () => {
  return (
    <div>
      <span className="loader"></span>
    </div>
  );
};

export default Loader_btn;
